import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/menu", label: "Menu" },
  { to: "/#featured", label: "Bouquets" },
  { to: "/#dessert", label: "Spotlight" },
  { to: "/#about", label: "About" },
  { to: "/#gallery", label: "Gallery" },
  { to: "/#testimonials", label: "Reviews" },
  { to: "/#contact", label: "Contact" },
];

export default function Navbar({ logoUrl }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 30);
    h();
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);

  useEffect(() => { setOpen(false); }, [loc]);

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
        scrolled ? "bg-ivory/90 backdrop-blur-xl border-b border-hairline" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20 flex items-center justify-between h-20 md:h-24">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          {logoUrl ? (
            <img src={logoUrl} alt="Tammy's Treats" className="h-12 md:h-14 w-auto" />
          ) : (
            <span className="font-display text-2xl tracking-tight">Tammy's Treats</span>
          )}
        </Link>

        <div className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            l.to.startsWith("/#") ? (
              <a key={l.to} href={l.to} data-testid={`nav-${l.label.toLowerCase()}`} className="elegant-link text-[11px] uppercase tracking-[0.22em] text-ink">
                {l.label}
              </a>
            ) : (
              <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase()}`} className="elegant-link text-[11px] uppercase tracking-[0.22em] text-ink">
                {l.label}
              </Link>
            )
          ))}
        </div>

        <div className="hidden lg:block">
          <Link to="/inquiry" data-testid="nav-inquiry-btn" className="btn-rose">Begin Inquiry</Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-ink"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X strokeWidth={1.25} /> : <Menu strokeWidth={1.25} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-ivory border-t border-hairline px-6 py-8 space-y-6">
          {links.map((l) => (
            l.to.startsWith("/#") ? (
              <a key={l.to} href={l.to} className="block text-sm uppercase tracking-[0.2em]" data-testid={`mobile-nav-${l.label.toLowerCase()}`}>
                {l.label}
              </a>
            ) : (
              <Link key={l.to} to={l.to} className="block text-sm uppercase tracking-[0.2em]" data-testid={`mobile-nav-${l.label.toLowerCase()}`}>
                {l.label}
              </Link>
            )
          ))}
          <Link to="/inquiry" className="btn-rose inline-block w-full text-center" data-testid="mobile-nav-inquiry">Begin Inquiry</Link>
        </div>
      )}
    </nav>
  );
}
